export const handleBack = () =>
  (window.location.href = '/e-learning/learning-path')
